import { gql, useMutation } from "@apollo/client";
import React, { ReactElement } from "react";

import { normalizeErrors } from "../../../../../utils/normalizeErrors";
import { NormalizedErrorMap } from "../../../../../types/NormalizedErrorMap";
import { CreateRefundAdminMutationMutation, CreateRefundAdminMutationMutationVariables } from "../../../../../schemaTypes";

export const createRefundAdminMutation = gql`
  mutation CreateRefundAdminMutation(
        $input: CreateRefundInputAdmin!
    ) {
        createRefundAdmin(
            input: $input
            ) {
            errors {
                path
                message
            }
            message
            data {
                id
                account_number
                bank_code
                full_name
                currency
                debit_currency
                amount
                fee
                status
                reference
                narration
                complete_message
                requires_approval
                is_approved
                bank_name
            }
        }
  }
`;

interface Props {
  children: (
    data: {
      submitCreateRefundAdmin: (
        values: CreateRefundAdminMutationMutationVariables
      ) => Promise<NormalizedErrorMap | any>;
      loading: boolean;
      error: any;
      message: string | null;
      createRefundAdminData: any | null; 
    }
  ) => ReactElement | null;
}

export const CreateRefundAdminController: React.FC<Props> = ({ children }) => {
  const [mutate, { loading, error, data }] = useMutation<
    CreateRefundAdminMutationMutation,
    CreateRefundAdminMutationMutationVariables
  >(
    createRefundAdminMutation
  );

  const submitCreateRefundAdmin = async (values: CreateRefundAdminMutationMutationVariables) => {
    const { data: {createRefundAdmin} }:any = await mutate({ variables: values });

    if (createRefundAdmin?.errors) {
      return {error: normalizeErrors(createRefundAdmin.errors), createRefundAdmin: null};
    }

    return {
      error: null,
      createRefundAdmin
    };
  };

  const message = data?.createRefundAdmin?.message || null;

  return children({
    submitCreateRefundAdmin,
    loading,
    error,
    message,
    createRefundAdminData: data,
  });
};